import { render, staticRenderFns } from "./RejectedMentorshipRequestsTable.vue?vue&type=template&id=6f6705c4&scoped=true&"
import script from "./RejectedMentorshipRequestsTable.vue?vue&type=script&lang=js&"
export * from "./RejectedMentorshipRequestsTable.vue?vue&type=script&lang=js&"
import style0 from "./RejectedMentorshipRequestsTable.vue?vue&type=style&index=0&id=6f6705c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6705c4",
  null
  
)

export default component.exports